export default "__VITE_ASSET__DSLKIYn4__"